// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"38a832ac","5249":"38a832ac","6528":"38a832ac","8122":"38a832ac"}[chunkId] + ".chunk.css";
};